import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { LoadingScreen } from '../app-active-loading/LoadingScreen';
import { getIsNewUserExperiment } from '../experiments/ExperimentUtils';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { getFlowKey } from '../routing/getFlowKey';
import { getActiveLoading } from '../store/loading-status/selectors';
import { useTracker } from '../tracking/useTracker';
import { getHubSpotConversationsClient } from './getHubSpotConversationsClient';
import { shouldShowChatBot } from './shouldShowChatBot';
import { useSetupChatbot } from './useSetupChatbot';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
export const useChatBot = () => {
  const {
    currentStep
  } = useCurrentStep();
  const [loaded, setLoaded] = useState(false);
  const [handlerAdded, setHandlerAdded] = useState(false);
  const isNewUser = useSelector(getIsNewUserExperiment);
  const flowKey = getFlowKey();
  const Tracker = useTracker();
  const activeLoading = useSelector(getActiveLoading);
  const isLoading = activeLoading && LoadingScreen[activeLoading];
  const {
    setupChatbot
  } = useSetupChatbot({
    loaded,
    setLoaded
  });
  const {
    isAssignedToVariant: isAssignedToACQ172Variant
  } = useExperiment(ExperimentKeys.ACQ0172, TrackWhen.never);
  const {
    isAssignedToVariant: isAssignedToACQ173Variant
  } = useExperiment(ExperimentKeys.ACQ0173, TrackWhen.never);
  const hideChatbotInExperiment = isAssignedToACQ172Variant() || isAssignedToACQ173Variant();
  useEffect(() => {
    const conversationsClient = getHubSpotConversationsClient();
    if (conversationsClient) {
      if (hideChatbotInExperiment && conversationsClient.widget && loaded) {
        conversationsClient.widget.remove();
        return;
      }
      setupChatbot();
      if (!handlerAdded) {
        setHandlerAdded(true);
        conversationsClient.on('conversationStarted', ({
          conversation
        }) => {
          Tracker.signupInteraction('chatbot-conversation-started', {
            currentStep,
            conversationId: conversation.conversationId
          });
        });
        conversationsClient.on('conversationClosed', ({
          conversation
        }) => {
          Tracker.signupInteraction('chatbot-conversation-ended', {
            currentStep,
            conversationId: conversation.conversationId
          });
        });
      }
    } else {
      window.hsConversationsOnReady = [() => {
        setupChatbot();
      }];
    }
    return () => {
      const showChatBot = shouldShowChatBot({
        flowKey
      });
      if (!showChatBot && conversationsClient && conversationsClient.widget && loaded) {
        conversationsClient.widget.remove();
        setLoaded(false);
      }
    };
  }, [currentStep, loaded, isNewUser, flowKey, Tracker, isLoading, handlerAdded, setHandlerAdded, setupChatbot, hideChatbotInExperiment]);
};